import React, { useState, useEffect } from "react";
import {
  Row
} from "reactstrap"
import Loading from 'lib/loading'
import rotas from '../../services/rotas'
import rest from '../../lib/rest'
import ValoresCard from '../../components/ValoresCard'

const Caixa = ()=> {

  const inicialValores = {
    ticketi: "00,00",
    venda_total: "00,00",
    farmaciaP: "00,00",
    convenio: "00,00",
    contasRecebidas: "00,00",
    compras: "00,00"
  }

  const [loading, setLoading] = useState(true)
  const [caixa, setCaixa]     = useState(inicialValores)

  const valores = () => {
    let lista = []
    const url = rotas.vendasTotal+'?tipo=mes'
    try{
      const retorno = rest.get(url)
      retorno.then(ret => {
        if (ret.success){
          lista = ret.lista
          setCaixa(lista)
          setLoading(false)
        }
      })
      return (lista)

    }catch(err){

    }
  }

  useEffect(() => {
    const load = loading
    if (load === true) {
      valores()
    }
  }, [])

  if (loading) {
    return (
      <Loading
        tipo='componente'
      />
    )
  }else {
    return (
      <Row>
        <ValoresCard
            cor='text-blue'
            icone='fa-coins'
            valor={caixa.venda_total}
            titulo='Vendas'
          />

          {/* <ValoresCard
            cor='text-success'
            icone='fa-hand-holding-usd'
            valor={caixa.contasRecebidas}
            titulo='Recebimentos'
          /> */}

          <ValoresCard
            cor='text-warning'
            icone='fa-briefcase-medical'
            valor={caixa.farmaciaP}
            titulo='Farmacia Popular'
          />

          {/* <ValoresCard
            cor='text-warning'
            icone='fa-file-invoice-dollar'
            valor={caixa.convenio}
            titulo='Convênios'
          /> */}

          <ValoresCard
            cor='text-danger'
            icone='fa-receipt'
            valor={caixa.ticketi}
            titulo='Ticket Médio'
          />

          <ValoresCard
            cor='text-danger'
            icone='fa-file-invoice'
            valor={caixa.compras}
            titulo='Compras'
          />
      </Row>
    )
  }
}

export default Caixa
